import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import Title from 'components/ui/general/Title';
import WebhooksCreate from './WebhooksCreate';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { createWebhook } from 'store/actions/webhooks/createWebhooks';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';

class WebhooksCreateContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            history,
            dispatchForm,
        } = this.props;

        return new Promise((resolve, reject) => {
            dispatchForm({
                onError: () => {
                    // This location should have where we bounce the error back to the form with SubmissionError.
                    reject();
                },
                onSuccess: () => {
                    resolve(history.push('/webhooks'));
                },
                values: values,
            });
        });
    }

    render() {
        const {
            translate,
        } = this.props;

        const breadcrumbs = [
            {
                label: translate('resources.webhooks.title'),
                link: '/webhooks',
            },
            {
                label: translate('actions.create'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.webhooks.actions.create') } />

                    <Actions>
                        <ListButton url='/webhooks' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <WebhooksCreate
                            form='webhooks_create'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

WebhooksCreateContainer.propTypes = {
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(createWebhook(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(WebhooksCreateContainer);



// WEBPACK FOOTER //
// ./src/pages/webhooks/create/WebhooksCreateContainer.js